// П23 (handoff fakt-support 06-animations.md): конфетти на оценку 5. Единственная анимация на JS:
// 90 бумажек со своей физикой CSS-переходами не собрать. Числа - из шейдера rate-confetti.glsl,
// менять только вместе с макетом p5c.
const COLORS = ['#FF9100', '#E91E63', '#4CAF50', '#2196F3', '#FFC107', '#FF3F00'] // палитра макета p5c
const PER_POPPER = 45 // бумажек в каждой хлопушке
const DRAG = 1.9 // 1/с: сопротивление воздуха
const GRAVITY = 420 // px/с²: бумага падает медленно
const FADE_FROM = 2.3 // с: начинают гаснуть
const LIFE = 3.2 // с: холст убираем

// Плавный шаг 0 → 1 между a и b, как smoothstep в шейдере.
function smooth (a, b, t) {
  const x = Math.min(Math.max((t - a) / (b - a), 0), 1)
  return x * x * (3 - 2 * x)
}

/**
 * Две хлопушки из верхних углов карточки оценки; холст ровно по ленте переписки, клики
 * проходят сквозь него. Без движения по настройке системы - без конфетти.
 */
export function launchConfetti (card, feed) {
  if (!card || !feed || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  const area = feed.getBoundingClientRect()
  const box = card.getBoundingClientRect()
  const dpr = window.devicePixelRatio || 1
  const canvas = document.createElement('canvas')
  canvas.width = area.width * dpr
  canvas.height = area.height * dpr
  Object.assign(canvas.style, {
    position: 'fixed',
    left: `${area.left}px`,
    top: `${area.top}px`,
    width: `${area.width}px`,
    height: `${area.height}px`,
    pointerEvents: 'none',
    zIndex: 10,
  })
  document.body.append(canvas)
  const ctx = canvas.getContext('2d')
  ctx.scale(dpr, dpr)

  const rnd = Math.random
  const bits = Array.from({ length: PER_POPPER * 2 }, (_, i) => {
    const left = i < PER_POPPER // первые 45 - левая хлопушка
    const tilt = (0.35 + 0.55 * rnd()) * (left ? 1 : -1) // 20-52° от вертикали, внутрь карточки
    const speed = 520 + 520 * rnd() // px/с
    const size = 0.75 + 0.5 * rnd()
    return {
      x0: (left ? box.left + 24 : box.right - 24) - area.left, // в 24 px от углов карточки
      y0: box.top + 16 - area.top, // и в 16 px от её верха
      vx: Math.sin(tilt) * speed,
      vy: -Math.cos(tilt) * speed, // минус - вверх
      w: 7 * size,
      h: 13 * size,
      angle: rnd() * Math.PI * 2,
      spin: (5 + 9 * rnd()) * (rnd() > 0.5 ? 1 : -1),
      sway: 5 + 4 * rnd(),
      flip: 6 + 8 * rnd(),
      color: COLORS[i % COLORS.length],
      phase: i,
    }
  })

  const t0 = performance.now()
  requestAnimationFrame(function frame (now) {
    const t = (now - t0) / 1000
    ctx.clearRect(0, 0, area.width, area.height)
    if (t >= LIFE) {
      canvas.remove()
      return
    }

    const fly = (1 - Math.exp(-DRAG * t)) / DRAG // путь с торможением, в долях начальной скорости
    const fall = (GRAVITY * t * t) / 2
    const swayAmp = 14 * smooth(0.2, 0.8, t) // покачивание ±14 px, включается плавно
    ctx.globalAlpha = 1 - smooth(FADE_FROM, LIFE, t)

    for (const b of bits) {
      const turn = Math.abs(Math.cos(t * b.flip + b.phase)) * 0.85 + 0.15 // кувырок: ширина 15-100%
      const w = b.w * turn
      ctx.save()
      ctx.translate(b.x0 + b.vx * fly + Math.sin(t * b.sway + b.phase) * swayAmp, b.y0 + b.vy * fly + fall)
      ctx.rotate(b.angle + b.spin * t)
      ctx.fillStyle = b.color
      ctx.fillRect(-w / 2, -b.h / 2, w, b.h)
      ctx.fillStyle = `rgba(0, 0, 0, ${(1 - turn) * 0.2})` // ребром к зрителю - темнее
      ctx.fillRect(-w / 2, -b.h / 2, w, b.h)
      ctx.restore()
    }
    requestAnimationFrame(frame)
  })
}
